import React from 'react'
import './QuestionCard.scss'

const QuestionCard = ({ children }) => {
  return (
    <div className='question-card'>
      {children}
    </div>
  )
}

export default QuestionCard